import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { DivisionService } from '../../../../services/divisions/division.service';
import {LightboxModule} from 'ngx-lightbox';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {FuseWidgetModule} from '../../../../../core/components/widget/widget.module';
import { SchoolScheduleComponent } from './school-schedule.component';
import { EventService } from '../../../../services/events/event.service';
import { EventTypeService } from '../../../../services/event-types/event-type.service';
import { AddEditSchoolScheduleComponent } from './add-edit-school-schedule/add-edit-school-schedule.component';
import { Md2Module } from 'md2';
import { CompatibilityModule } from 'md2';
import { NoConflictStyleCompatibilityMode } from 'md2';

const routes = [
    {
        path: 'pages/events/school-schedule',
        component: SchoolScheduleComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_SCHOOL_SCHEDULE',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        SchoolScheduleComponent,
        AddEditSchoolScheduleComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        Md2Module,
        CompatibilityModule,
        NoConflictStyleCompatibilityMode
    ],
    exports: [
        SchoolScheduleComponent,
    ],
    entryComponents: [
        AddEditSchoolScheduleComponent
    ],
    providers: [
        EventService,
        DivisionService,
        EventTypeService
    ]
})

export class SchoolScheduleModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/events/school-schedule/school-schedule.module.ts